import { useEffect } from 'react';
import $ from 'jquery'; 

function ScrollHandler() {
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = $('.back-to-top');
            if (window.scrollY > 1000) {
                scrollTop.fadeIn(1000); 
            } else {
                scrollTop.fadeOut(1000);
            }

            // Sticky menu activation
            const navbarArea = document.querySelector('.navbar-area');
            if (window.scrollY >= 1) {
                navbarArea.classList.add('navbar-area-fixed');
            } else {
                navbarArea.classList.remove('navbar-area-fixed');
            }
        };

        // // Load event listener
        // const handleLoad = () => {
        //     // Preloader
        //     const preLoader = document.querySelector("#preloader");
        //     preLoader.style.transition = 'opacity 1000ms'; 
        //     preLoader.style.opacity = '0'; 
        //     setTimeout(() => {
        //         preLoader.style.display = 'none'; 
        //     }, 1000);

        //     // Back to top
        //     const backToTop = document.querySelector('.back-to-top');
        //     backToTop.style.display = 'none';

        //     // click to back on top 

        // };

        // Attach event listeners
        window.addEventListener('scroll', handleScroll);
        // window.addEventListener('load', handleLoad);

        // Cleanup function
        return () => {
            window.removeEventListener('scroll', handleScroll);
            // window.removeEventListener('load', handleLoad);
        };
    }, []);

    return null;
}

export default ScrollHandler;
